type WhatsAppCapableIncident = {
  whatsappNotificationAvailable?: boolean;
  customer?: {
    mobilePhone?: string;
  } | null;
};

export function isWhatsAppNotificationAvailable(
  incident?: WhatsAppCapableIncident | null,
): boolean {
  if (!incident) return false;
  if (incident.whatsappNotificationAvailable === true) return true;
  if (incident.whatsappNotificationAvailable === false) return false;
  return Boolean(incident.customer?.mobilePhone?.trim());
}

export function whatsappRecipientFallback(incident?: WhatsAppCapableIncident | null): string {
  return incident?.customer?.mobilePhone?.trim() || "";
}
